export class EmailsHistoryFilter {
    public Keywords: string = '';
    public Type: string | null = null;
}

export interface EmailBatchResource {
    Id: number;
    BatchGuid: string;
    Name: string;
    TemplateMessage: string;
    FromEmail: string | null;
    Subject: string | null;
    AutomationId: number | null;
    AutomationName: string | null;
    TotalQty: number;
    SentQty: number;
    OpenedQty: number;
    FailedQty: number;
    RemainingQty: number;
    ErrorMessage: string | null;
    Status: string | number;
    CreatedAt: string | Date;
    TemplateId: string | null;
    ProfileId: number | null;
    ContactGroups: [];
    ScheduledAt: string | null;
    UnsubscribeText: string | null;
}

export class EmailSendingSettings {
    public Id: number | null = null;
    public Name: string = '';
    public Subject: string = '';
    public Message: string = '';
    public ProfileId: number | null = null;
    public ContactGroups = [];
    public Unsubscribe = false;
    public UnsubscribeText: string | null = '';
    public TemplateId: string | null = null;
    public ReplaceLink = false;
    public Scheduled = false;
    public ScheduledAt: string | null = null;
    public ScheduledDate: string | null = null;
    public ScheduledTime: string | null = null;
}

export class SendTestEmailModel {
    public Email: string = '';
    public Message: string = '';
    public Subject: string = '';
    public ReplaceLink = false;
    public Unsubscribe = false;
    public UnsubscribeText: string | null = null;
    public ProfileId: number | null = null;
}

export interface EmailBatchHistoryResult {
    LastId: number;
    HasNext: boolean;
    Rows: EmailBatchResource[];
}

export class EmailsProfilesFilter {
    public Keywords: string = '';
    public OrderBy: string = 'CreatedFirst';
}
export interface EmailProfileRowResource {
    Id: number;
    Name: string;
    FromName: string;
    FromEmail: string;
    CreatedAt: string | null;
}
export interface EmailProfileResource extends EmailProfileRowResource {
    ReplyEmail: string | null;
    UpdatedAt?: string;
}
export interface EmailProfilesResult {
    PageIndex: number;
    HasNext: boolean;
    Rows: EmailProfileRowResource[];
}
